import { useOnValueChange } from '@calendly/hooks'
import { Loader } from '@calendly/ui/components/loader'
import { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setCurrentContactProfile, useFetchContactByEmailQuery, isContactDrawerOpenSelector } from 'features/contacts'

import { AvatarDropdown } from './avatar_dropdown'
import { FullStoryExclude } from '../../../../../../shared/fullstory_privacy'

const ContactsSearchHandler = ({ query, onResults, onFetching, isGuest }) => {
  const { data: contact, isFetching } = useFetchContactByEmailQuery(query, { skip: isGuest })

  useEffect(() => {
    onFetching(isFetching)
  }, [isFetching, onFetching])

  useEffect(() => {
    onResults(contact ? [contact] : [])
  }, [contact, onResults])

  return null
}

export const LegacyInvitee = ({
  isCancelled,
  isRescheduled,
  isConfirmed,
  isGuest,
  openEditEmailModal,
  isGroup,
  turnOnNoShowClicked,
  canEditEmail,
  canMarkNoShow,
  canBlock,
  canUnblock,
  event,
  invitee,
  toggle,
  isOpen,
  sendAnalytics,
}) => {
  const [contact, setContact] = useState()
  const [isFetching, setIsFetching] = useState(false)
  const handleResults = (results) => {
    setContact(results?.[0])
  }
  const displayName = contact?.name || invitee.name || invitee.email
  const nameButtonRef = useRef()

  const isContactDrawerOpen = useSelector(isContactDrawerOpenSelector)

  const dispatch = useDispatch()

  const [openContactDrawer, setOpenContactDrawer] = useState(false)

  useOnValueChange(isContactDrawerOpen, () => {
    if (openContactDrawer) {
      nameButtonRef.current?.focus()
    }
  })

  const onLegacyHeaderClick = () => {
    if (isGuest) return

    if (sendAnalytics) sendAnalytics()
    if (contact) {
      setOpenContactDrawer(true)
      dispatch(setCurrentContactProfile(contact))
    } else {
      toggle()
    }
  }

  return (
    <FullStoryExclude>
      <ContactsSearchHandler
        query={invitee.email}
        onResults={handleResults}
        onFetching={setIsFetching}
        isGuest={isGuest}
      />
      {isFetching && <Loader data-testid="contact-loader" size="small" />}
      {!isFetching && (
      <AvatarDropdown
        displayName={displayName}
        isCancelled={isCancelled}
        isRescheduled={isRescheduled}
        isConfirmed={isConfirmed}
        isGuest={isGuest}
        contact={contact}
        onHeadingClick={onLegacyHeaderClick}
        openEditEmailModal={openEditEmailModal}
        nameButtonRef={nameButtonRef}
        isGroup={isGroup}
        turnOnNoShowClicked={turnOnNoShowClicked}
        canEditEmail={canEditEmail}
        canMarkNoShow={canMarkNoShow}
        canBlock={canBlock}
        canUnblock={canUnblock}
        event={event}
        invitee={invitee}
        toggle={toggle}
        isOpen={isOpen}
        isLegacy
      />
      )}
    </FullStoryExclude>
  )
}
